type DashboardOption = {
    label: string;
    code: string;
    component?: string;
    role?: string;
};

const DASHBOARD_OPTIONS: DashboardOption[] = [
    { label: "Năm NV bán hàng theo kênh", code: "BAN_HANG_NV", component: "SalesEmployeeYear" },
    { label: "Năm tất cả NV bán hàng theo kênh", code: "BAN_HANG_CAC_NV", component: "SalesAllEmployeeYear", role: "global" },
    { label: "Tháng NV bán hàng theo kênh", code: "BAN_HANG_NV_MONTH", component: "SalesEmployeeMonth" },
    { label: "Tháng tất cả NV bán hàng theo kênh", code: "BAN_HANG_CAC_NV_MONTH", component: "SalesAllEmployeeMonth", role: "global" },
    { label: "Tât cả NV bán hàng theo tháng", code: "BAN_HANG_NV_BY_MONTH", component: "SalesByAllEmployeesMonth",  role: "global" },
    { label: "NV khảo sát", code: "KHAO_SAT_NV", component: "SurveyEmployee" },
    { label: "Tất cả NV khảo sát", code: "KHAO_SAT_CAC_NV", component: "SurveyAllEmployee", role: "global" },
    { label: "NV CNC", code: "CNC_NV", component: "CNCEmployee" },
    { label: "Tất cả NV CNC", code: "CNC_CAC_NV", component: "CNCAllEmployee", role: "global" },
    { label: "Nhiệm vụ VN", code: "NHIEM_VU_NV", component: "TaskEmployee" },
    { label: "Tất cả nhiệm vụ NV Sale", code: "BAN_HANG", component: "TaskAllEmployee", role: "global" },
    { label: "Tất cả nhiệm vụ NV CNC", code: "CNC", component: "TaskAllEmployee", role: "global" },
    { label: "Tất cả nhiệm vụ NV Khảo sát", code: "KHAO_SAT", component: "TaskAllEmployee", role: "global" },

];

export { DASHBOARD_OPTIONS };